import { useQuery, useMutation } from "react-query";
import {
	create_subscription_plan,
	get_subscription_plans,
	update_subscription_plans,
	restaurant_gift_config,
	get_restaurant_subscriptions,
	get_restaurant_subscription_by_id,
	patch_restaurant_subscription_by_id,
	get_subscription_history_by_restaurant,
} from "../services/subscriptions";

export const useGetSubscriptionPlans = (payload) =>
	useQuery(["getSubscriptionPlans", payload], () =>
		get_subscription_plans(payload)
	);

export const useUpdateSubscriptionPlan = (payload) =>
	useMutation(["updateSubscriptionPlan", payload], (payload) =>
		update_subscription_plans(payload)
	);

export const useCreateSubscriptionPlan = (payload) =>
	useMutation(["createSubscriptionPlan", payload], (payload) =>
		create_subscription_plan(payload)
	);
export const useRestaurantConfig = (payload) =>
	useMutation(["restaurantConfig", payload], (payload) =>
		restaurant_gift_config(payload)
	);

export const useGetRestaurantPlans = (payload) =>
	useQuery(["getRestaurantPlans", payload], () =>
		get_restaurant_subscriptions(payload)
	);
export const useGetRestaurantPlanById = () =>
	useMutation(["getRestaurantPlanById"], (payload) =>
		get_restaurant_subscription_by_id(payload)
	);
export const usePatchRestaurantPlanById = () =>
	useMutation(["patchRestaurantPlanById"], (payload) =>
		patch_restaurant_subscription_by_id(payload)
	);
export const useGetRestaurantHistory = (id) =>
	useMutation(["getRestaurantHistory", id], (id) =>
		get_subscription_history_by_restaurant(id)
	);
